
import { Search } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '../../components/ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '../../components/ui/avatar';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useToast } from '../../hooks/use-toast';

interface HeaderProps {
  isLoggedIn?: boolean;
  title: string;
  subtitle?: string;
}

const Header = ({ isLoggedIn = true, title, subtitle }: HeaderProps) => {

  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    await signOut(auth);
    localStorage.clear();
    window.location.href = "/login";
    toast({
      title: "Logged out successfully",
      description: "You have been logged out of your account",
    });
    // Add actual logout logic here if necessary  
  };

  return (
    <header className="py-3 px-8 flex flex-col md:flex-row md:items-center justify-between space-y-4 md:space-y-0 border-b border-gray-100 bg-white">
      <div className="flex-1">
        <h1 className="text-2xl font-semibold text-gray-800">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>

      <div className="flex items-center space-x-6">
        <div className="relative max-w-md w-full">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
          <Input
            type="search"
            placeholder="Search Here"
            className="pl-10 pr-4 py-2 w-full bg-gray-50 border-gray-200 focus:bg-white"
          />
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm" className="flex items-center h-9 gap-2 bg-transparent hover:bg-gray-50">
              <span className="text-gray-600">EN</span>
              <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center text-white">
                <span className="text-xs">🇺🇸</span>
              </div>
              <span className="text-gray-600 text-xs ml-1">IND</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center text-white">
                  <span className="text-xs">🇺🇸</span>
                </div>
                <span>English</span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center text-white">
                  <span className="text-xs">🇮🇳</span>
                </div>
                <span>Hindi</span>
              </div>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        {
          isLoggedIn &&
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="flex items-center h-9 gap-3 bg-transparent hover:bg-gray-50">
                <Avatar>
                  <AvatarImage src="https://github.com/shadcn.png" />
                  <AvatarFallback>AD</AvatarFallback>
                </Avatar>
                <div className="text-left">
                  <p className="text-sm font-medium text-gray-700">Admin</p>
                  <p className="text-xs text-gray-500">Super Admin</p>
                </div>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem>Profile</DropdownMenuItem>
              <DropdownMenuItem>Settings</DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleLogout()}>Logout</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        }

      </div>
    </header>
  );
};

export default Header;
